module.exports = __webpack_public_path__ + "static/media/battery-three-quarters.d9ef95fb.svg";